import React from 'react';

import {Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import {Else, If, Then, When} from 'react-if';

import {useAppSelector} from 'hooks';
import {useBasketCalculations} from 'hooks/useBasketCalculations';
import {formatPriceWithCurrency} from 'utils/currency';

const BasketDeliveryFee: React.FC = () => {
  const {basket} = useAppSelector((state) => state?.basket) || {};
  const {priceUnit, defaultShippingFee} = useBasketCalculations();
  const prices = basket?.prices;

  if (!prices) {
    return null;
  }

  const originalShippingFee = prices?.shippingFee;

  const makroSeller = prices?.priceBreakdown?.filter((item) => item.is3PSeller !== true)[0];

  const discountedShippingFee = prices.shippingFee + (makroSeller?.shippingFee === 0 ? defaultShippingFee : 0);

  return (
    <Stack direction="row" spacing={1}>
      <When condition={makroSeller?.shippingFee === 0}>
        <Typography fontSize="inherit" fontWeight="inherit" style={{textDecoration: 'line-through'}}>
          {formatPriceWithCurrency(discountedShippingFee, priceUnit)}
        </Typography>
      </When>
      <Typography fontSize="inherit" fontWeight="inherit">
        <If condition={originalShippingFee === 0 && basket.basketItems.length}>
          <Then>
            <Typography color={'primary'} sx={{fontWeight: 'bold'}}>
              {t('label.free')}
            </Typography>
          </Then>
          <Else>{formatPriceWithCurrency(originalShippingFee, priceUnit)}</Else>
        </If>
      </Typography>
    </Stack>
  );
};

BasketDeliveryFee.displayName = 'BasketDeliveryFee';
export default BasketDeliveryFee;
